import './App.css';
import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

// Components
import Header from './components/header/Header'; // Universal Header
import Footer from './components/footer/Footer'; // Universal Footer
import ListingPage from './pages/listing/ListingPage';
import MenuPage from './pages/menu_page/MenuPage';
import NewStores from './pages/new_stores/newStores';

// Pages - Lazy loading the pages to optimize performance
const HomePage = lazy(() => import('./pages/home_page/HomePage'));
const LoginRegister = lazy(() => import('./pages/login_register/LoginRegister'));
const AboutUs = lazy(() => import('./pages/about_us/AboutUs'));
const ContactUs = lazy(() => import('./pages/contact_us/ContactUs'));
const AdminDashboard = lazy(() => import('./pages/admin_dashboard/Admindashboard'));
const PrivacyPolicy = lazy(() => import('./pages/privacy_policy/PrivacyPolicy'));
const Disclaimer = lazy(() => import('./pages/disclaimer/Disclaimer'));
const TermsAndConditions = lazy(() => import('./pages/terms_and_conditions/TermsAndConditions'));
const NutritionalInformation = lazy(() => import('./pages/nutritional_information/NutritionalInformation'));
// const Feedback = lazy(() => import('./pages/feedback/Feedback'));

function App() {
  return (
      <div className="App">
        <Header/> {/* Universal Header */}

        {/* Lazy loading the routes */}
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<HomePage />} /> {/* HomePage is the default route */}
            <Route path="/about" element={<AboutUs />} /> {/* About Us */}
            <Route path="/contact" element={<ContactUs />} /> {/* Contact Us */}
            <Route path="/dashboard" element={<AdminDashboard />} /> {/* Admin Dashboard */}
            <Route path="/login" element={<LoginRegister />} /> {/* Login/Register */}
            <Route path="/listing" element={<ListingPage />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/new-stores" element={<NewStores />} />
            <Route path="/disclaimer" element={<Disclaimer />} /> {/* Disclaimer */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} /> {/* Privacy Policy */}
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} /> {/* Terms & Conditions */}
            <Route path="/nutritional-information" element={<NutritionalInformation />} /> {/* Nutritional Information */}
            {/* <Route path="/feedback" element={<Feedback />} /> Feedback */}
          </Routes>
        </Suspense>

        <Footer/> {/* Universal Footer */}
      </div>
  );
}

export default App;
